import { Component } from 'react';
import { connect } from 'react-redux';
import { FilterProvider } from '../../contexts/FilterContext';
import TaskSearch from './_components/TaskSearch';
import { combineTreatmentActions } from "./reducer";
import ServiceTasks from './ServiceTasks';
import TreatmentTasks from './TreatmentTasks';

interface IProps {
    getLists(): void
}

class OperationTaskBuilderPage extends Component<IProps> {
    constructor(props: IProps) {
        super(props);
        this.props.getLists();
    }

    render() {
        return <div className='m-header bgPage'>
            <div className='header-page'>
                <div className='title-page'>
                    <span className='font-w2 mr-1'>Setting:</span>
                    <b>Operation, task builder</b>
                </div>
            </div>
            <FilterProvider>
                <div className='body-page' data-box='true'>
                    <TaskSearch />
                    <div className='flex flex-col gap-3'>
                        <TreatmentTasks />
                        <ServiceTasks />
                    </div>
                </div>
            </FilterProvider>
        </div>;
    }
}

export default connect(null, {
    getLists: combineTreatmentActions.getListRequest
})(OperationTaskBuilderPage);